<style scoped>
.this__btn {
  width: 154px !important;
}
</style>
<template>
  <a-tooltip :visible="process" placement="bottomLeft">
    <div class="p-all share-tooltip" slot="title">
      {{ $t("Share about") }}
    </div>
    <a-button
      class="demo__button"
      v-bind:class="{
        'share-button-ok': process,
        'demo__button--base': !process,
        this__btn: windowWidth > 1630,
      }"
      @click="copy"
    >
      <div class="share-button-inner">
        <i
          class="fa-light"
          v-bind:class="{
            'fa-check': process_text,
            'fa-share-nodes': !process_text,
          }"
        ></i>
        <span v-if="windowWidth > 1630" class="demo__margin-left--9">{{
          process_text ? this.$t("Share done") : this.$t("Share")
        }}</span>
      </div>
    </a-button>
  </a-tooltip>
</template>

<script>
export default {
  props: {
    windowWidth: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      process: false,
      process_text: false,
      timeout: undefined,
    };
  },
  watch: {
    process(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.process_text = val;
      }, 100);
    },
  },
  mounted() {
    this.$accessModule("copy_page", this);
  },
  methods: {
    copy() {
      if (this.process) {
        return;
      }
      this.process = true;
      this.$root.$emit("copyShareString");

      setTimeout(() => {
        this.process = false;
      }, 2000);
    },
  },
};
</script>
